export enum enmStopFreeSaleStatus {
    New = 1,
    Cancel = 2
}